<template>
  <a-card style="margin-top: 16px">
    <h2>Zgłoszenia</h2>
    <a-row :gutter="[8, 8]">
      <a-col :span="24">
        <a-checkable-tag v-model="issueType.open" @change="changeIssueType">
          Otwarte
        </a-checkable-tag>
        <a-checkable-tag v-model="issueType.resolved" @change="changeIssueType">
          Zakończone
        </a-checkable-tag>
      </a-col>
      <a-col :span="24" v-for="issue in issues" :key="issue.issueId">
        <SingleIssue :issue="issue" @changed="getIssues" />
      </a-col>
      <a-col v-if="(issues.length === 0 && !loadingIssues)" :span="24">
        <a-empty v-if="(issues.length === 0)" style="margin-top: 3em;">
          <span slot="description" style="color: rgba(0, 0, 0, 0.65)">
            <strong>Brak zgłoszeń na tej liście!</strong>
            <p>Możesz dodać nowe z poziomu profilu użytkownika.</p>
          </span>
        </a-empty>
      </a-col>
      <a-col :span="24">
        <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
        >
          <a-spin v-if="loadingIssues"/>
          <a-button v-else @click="onLoadMore({current: issuesPagination.current + 1, pageSize: issuesPagination.pageSize})">
            Wczytaj więcej
          </a-button>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>
<script>
import httpClient from "@/utils/httpClient";
import SingleIssue from "@/components/issue/SingleIssue.vue";

export default {
  components: {SingleIssue},
  data() {
    return {
      issueType: {
        open: true,
        resolved: false
      },
      issues: [],
      issuesPagination: {
        current: 1,
        pageSize: 5,
        total: 1,
        defaultPageSize: 5,
      },
      loadingIssues: false,
      loadingMore: false,
      showLoadingMore: true,
    }
  },
  mounted() {
    this.getIssues()
  },
  methods: {
    getIssues() {
      this.loadingIssues = true;
      httpClient
          .get(`/admin/issues?size=${this.issuesPagination.pageSize}&page=${this.issuesPagination.current}&statuses=${this.selectedStatuses()}`)
          .then((response) => {
            this.issuesPagination = response.page;
            this.issues = response.payload;
            this.showLoadingMore = this.issuesPagination.total > this.issues.length
          }).catch((error) => {
        if (error.response.status !== 401) {
          this.$message.error("Wystąpił błąd wczytywania zgłoszeń")
        }
      }).finally(() => {
        this.loadingIssues = false;
      });
    },

    selectedStatuses() {
      let statuses = []
      if (this.issueType.open) {
        statuses.push("OPEN")
      }
      if (this.issueType.resolved) {
        statuses.push("RESOLVED")
      }
      return statuses.join(",")
    },

    changeIssueType() {
      this.issues = []
      this.issuesPagination.current = 1
      if (!this.issueType.open && !this.issueType.resolved) {
        this.issueType.open = true
      }
      this.getIssues()
    },

    onLoadMore(pagination) {
      const {current, pageSize} = pagination;
      this.issuesPagination.current = current
      this.issuesPagination.pageSize = pageSize

      this.loadingMore = true
      this.getIssues()
    }
  }
}
</script>

<style>
.ant-list-item-meta-title {
  margin-bottom: 0 !important;
}
</style>
